import { gql } from "@apollo/client";
import { blockchainAnimalFragment } from "api/Blockchain/fragment";

export const GET_BLOCKCHAIN_ANIMAL_DATA_BY_PASSPORT = gql`
  query GetBlockchainAnimalDataByPassport($passportNumber: String!) {
    blockchainAnimalDataByPassport(passportNumber: $passportNumber) {
      ...blockchainAnimalFragment
    }
  }
  ${blockchainAnimalFragment}
`;

export const GET_BLOCKCHAIN_ANIMAL_DATA_BY_KILL_NUMBER = gql`
  query GetBlockchainAnimalDataByKillNumber($killNumber: String!, $date: Date!) {
    blockchainAnimalDataByKillNumber(killNumber: $killNumber, date: $date) {
      ...blockchainAnimalFragment
    }
  }
  ${blockchainAnimalFragment}
`;
